export enum DateTimeRangeType {
  CTRL_REF_DATETIME,
  CUSTOM_VALUE,
  DATE,
}
